const gaId = '';

const getGaId = () => {
  return gaId;
};

export default getGaId;
